import { HttpClient, HttpHeaders } from '@angular/common/http';
var LocalApiService = /** @class */ (function () {
    function LocalApiService(httpClient) {
        this.httpClient = httpClient;
        this._STB_WEBSOCKET_URL = 'ws://localhost:10016/ui/subscriptionChanged';
    }
    Object.defineProperty(LocalApiService.prototype, "STB_WEBSOCKET_URL", {
        get: function () {
            return this._STB_WEBSOCKET_URL;
        },
        enumerable: true,
        configurable: true
    });
    LocalApiService.prototype.getBoxLanguage = function () {
        return this.httpClient.get(LocalApiService.BOX_PROXY_URL + '/settings/getSetting/profile.osdLang');
    };
    LocalApiService.prototype.verifyPin = function (pin) {
        var body = { 'pin': pin, 'pinType': 'master' };
        return this.httpClient.post(LocalApiService.BOX_PROXY_URL + '/auth/verifyPin', body);
    };
    LocalApiService.prototype.getRemainingAttempts = function () {
        var body = { 'pinType': 'master' };
        return this.httpClient.put(LocalApiService.BOX_PROXY_URL + '/auth/getRemainingAttempts', body);
    };
    LocalApiService.prototype.getSuspensionExpiration = function () {
        var body = { 'pinType': 'master' };
        return this.httpClient.put(LocalApiService.BOX_PROXY_URL + '/auth/getSuspensionExpiration', body);
    };
    LocalApiService.prototype.getBoxCpeId = function () {
        var httpOptions = {
            withCredentials: false,
            headers: new HttpHeaders({
                'accept': 'application/json',
                'Content-Type': 'application/json'
            })
        };
        return this.httpClient.get(LocalApiService.BOX_PROXY_URL + '/configuration/getConfig/cpe.id', httpOptions);
    };
    LocalApiService.BOX_PROXY_URL = 'http://localhost:10414';
    return LocalApiService;
}());
export { LocalApiService };
